module.exports = __webpack_public_path__ + "static/media/jungle-crossroad-off.13ea9ed4.png";